/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityScreenerSettingsEntry
 */
export interface FacilityScreenerSettingsEntry {
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    settings: { [key: string]: any; };
}

/**
 * Check if a given object implements the FacilityScreenerSettingsEntry interface.
 */
export function instanceOfFacilityScreenerSettingsEntry(value: object): value is FacilityScreenerSettingsEntry {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('settings' in value) || value['settings'] === undefined) return false;
    return true;
}

export function FacilityScreenerSettingsEntryFromJSON(json: any): FacilityScreenerSettingsEntry {
    return FacilityScreenerSettingsEntryFromJSONTyped(json, false);
}

export function FacilityScreenerSettingsEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityScreenerSettingsEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'settings': json['settings'],
    };
}

export function FacilityScreenerSettingsEntryToJSON(json: any): FacilityScreenerSettingsEntry {
    return FacilityScreenerSettingsEntryToJSONTyped(json, false);
}

export function FacilityScreenerSettingsEntryToJSONTyped(value?: FacilityScreenerSettingsEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'settings': value['settings'],
    };
}

